import Vue from "vue";
import Router from "vue-router";
import Home from "../components/HomePage.vue";
import Detail from "../components/DetailPage.vue";

Vue.use(Router);

const routes = [
  { path: "/", component: Home },
  { path: "/detail", component: Detail },
];

const router = new Router({
  mode: "hash",
  routes: routes,
  //增加这个配置
  scrollBehavior(to, from, savedPosition) {
    console.log(savedPosition);
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});
export default router;
